// PageVariablesEmpresas.js

export const pageVariables = {
    headers: [
        'NOME', 'DESCRIÇÃO', 'EMPRESA', 'SEGURADORA'
    ],
    headerInfo: {
        title: "Planos",
        description: "Esta seção fornece informações detalhadas sobre os planos, incluindo empresa e seguradora associadas."
    },     
    inputs: [
        {
            name: "nome",
            type: "text",
            label: "Nome"
        },
        {
            name: "descricao",
            type: "text",
            label: "Descrição"
        },
        {
            name: "empresa_nome",
            type: "text",
            label: "Empresa",
            readonly: true
        },
        {
            name: "seguradora_nome",
            type: "text",
            label: "Seguradora",
            readonly: true
        },
        {
            name: "tipo_plano",
            type: "select",
            label: "Tipo de Plano",
            options: ["Vida em Grupo", "Vida Individual"]
        },
        {
            name: "idade_maxima_ingresso_titular",
            type: "number",
            label: "Idade Máx. Ingresso Titular"
        },
        {
            name: "permite_dependente",
            type: "select",
            label: "Permite Dependente?",
            options: ["Sim", "Não"],
            castBoolean: true
        },
        {
            name: "idade_maxima_ingresso_dependente",
            type: "number",
            label: "Idade Máx. Dependente"
        },
        {
            name: "capital_maximo_global",
            type: "number",
            label: "Capital Máximo Global (R$)"
        },
        {
            name: "possui_iof",
            type: "select",
            label: "Incide tributo de IOF (0,38%)?",
            options: ["Sim", "Não"],
            castBoolean: true
        },
        {
            name: "tipo_ipca",
            type: "select",
            label: "Fonte do Índice IPCA",
            options: ["Automatizado (Banco Central via API)", "Manual (Tabela Interna de Gestão)"]
        }
    ],
    page: process.env.VUE_APP_API_URL+"planos",
    planosFilterPage: process.env.VUE_APP_API_URL+"planos/filter"
};
